import React, { useState } from 'react';
import ApplicationCard from '../LandlordDashboard/ApplicationCard';
import ApplicantModal from './ApplicantModal';
import styles from '../../styles/Building MGMT/UnitApplications.module.css';

const UnitApplications = ({ unitId, handleBack }) => {
  const [activeTab, setActiveTab] = useState('All');
  const [selectedApplicant, setSelectedApplicant] = useState(null);

  const [applications, setApplications] = useState([
    {
      id: 1,
      applicant: 'John Doe',
      type: 'Single',
      timeAgo: '2 hrs ago',
      assessment: 'Strong',
      creditScore: 750,
      incomeRentRatio: '3.5x',
      criminal: 'None',
      adverse: 'None',
      status: 'Pending',
      isNew: true,
    },
    {
      id: 2,
      applicant: 'Jane Smith',
      type: 'Single',
      timeAgo: '1 day ago',
      assessment: 'Moderate',
      creditScore: 680,
      incomeRentRatio: '2.9x',
      criminal: 'None',
      adverse: 'Late Payments',
      status: 'Approved',
    },
    {
      id: 3,
      applicant: 'Mike Brown',
      type: 'Single',
      timeAgo: '3 days ago',
      assessment: 'Weak',
      creditScore: 620,
      incomeRentRatio: '2.0x',
      criminal: 'Minor',
      adverse: 'Late Payments',
      status: 'Rejected',
    },
  ]);

  const openApplicantModal = (applicant) => setSelectedApplicant(applicant);
  const closeApplicantModal = () => setSelectedApplicant(null);

  const handleAccept = (id) => {
    setApplications(prev => prev.map(app => app.id === id ? {...app, status: 'Approved'} : app));
    closeApplicantModal();
  };

  const handleReject = (id) => {
    setApplications(prev => prev.map(app => app.id === id ? {...app, status: 'Rejected'} : app));
    closeApplicantModal();
  };

  const filteredApplications = activeTab === 'All'
    ? applications
    : applications.filter(app => app.status === activeTab);

  return (
    <div className={styles.container}>
	  <button className={styles.backToUnitsButton} onClick={handleBack}>
        ← Back to Units
      </button>

      <h2 className={styles.pageTitle}>Applications for Unit #{unitId}</h2>

      <div className={styles.tabs}>
        {['All', 'Pending', 'Approved', 'Rejected'].map(tab => (
          <button
            key={tab}
            className={`${styles.tabButton} ${activeTab === tab ? styles.tabActive : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className={styles.applicationsList}>
        {filteredApplications.map(app => (
          <div key={app.id} onClick={() => openApplicantModal(app)}>
            <ApplicationCard application={app} />
          </div>
        ))}
      </div>

      <ApplicantModal
        applicant={selectedApplicant}
        onClose={closeApplicantModal}
        onAccept={handleAccept}
        onReject={handleReject}
      />
    </div>
  );
};

export default UnitApplications;
